<template>
  <div>
    <template v-if="!loading">
      <div 
        :style="{ backgroundImage: bgCard }"
        class="member-card">
          <div class="profile-image-wrapper">
              <img
                :src="profileImage"    
                class="profile-image"            
              />
          </div>
          <div class="member-card-text" :class="{'text-gold-card' : member.member_type == 'gold'}">
            <div class="float-left">
              <div class="member-card-name">{{ member.name }}</div>
              <div><span style="font-weight: 600; text-transform: uppercase;">Member ID </span> LM{{ member.id.padStart(5,'0')  }}</div>
            </div>
            <div class="float-right text-right">
              <div style="font-weight: 600;">ยอดซื้อสะสม</div> 
              <template v-if="member.totalPurchase">
                <div>{{ member.totalPurchase | numberCurrency }} บาท</div>
              </template>
              <template v-else>
                <div>0 บาท</div>
              </template>
            </div>
          </div>
        </div>
        <!-- Remark -->
        <div class="text-center" style="font-size: 13px; color: #999;">
          <template v-if="member.member_type == 'gold'">
            (ยอดสะสมซื้อถึง Gold Member แล้ว)
          </template>
          <template v-else>
            (สะสมยอดซื้ออีก {{ remainPurchase | numberCurrency }} บาท เพื่อ upgrade เป็น {{ nextLevel }})
          </template>
        </div>
    </template>
    <template v-else>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          class="mt-6"
          color="primary"
          size="65"
        ></v-progress-circular>
      </div>
    </template>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        bgCard: '',
        remark: '',
        loading: true,
        profileImage: '',
        nextLevel: '',
        remainPurchase: 0,
        // member: {},
      }
    },
    mounted() {
      // this.member = this.$store.state.member;

      this.onSetCard();
    },
    computed: {
      member() {
        return this.$store.state.member;
      },
    },
    methods: {
      onSetCard() {
        if(Object.keys(this.member).length == 0) {
          return 
        }

        this.profileImage = this.$store.state.profile.pictureUrl;
        
        // if(this.member.profile_pic) {
        //   // this.profileImage = this.member.profile_pic;
        //   this.profileImage = this.$store.state.profile.pictureUrl;
        // } else {
        //   this.profileImage = require("../assets/images/profile-placeholder.png");
        // }

        var totalPurchase = this.member.totalPurchase;

        if(this.member.member_type == "new") { // New Member
          var nextTier = 4500;
          this.remainPurchase = parseFloat(nextTier - totalPurchase).toFixed(2);
          this.nextLevel = "Silver Member";
          this.bgCard = 'url(' + require(`@/assets/images/card-new-member.png`) + ')';

        } else if(this.member.member_type == "silver") { // Silver Member
          var nextTier = 8500;
          this.remainPurchase = parseFloat(nextTier - totalPurchase).toFixed(2);
          this.nextLevel = "Gold Member";
          this.bgCard = 'url(' + require(`@/assets/images/card-silver-member.png`) + ')';
        } else { // Gold Member
          this.bgCard = 'url(' + require(`@/assets/images/card-gold-member.png`) + ')';
        }
      
        this.loading = false;
      },
    },
    watch : {
      member(newval,oldval) {
        if(newval != oldval) {
          this.onSetCard();
        }
      }
    },
    filters: {
      numberCurrency: function (value) {
        var formatter = new Intl.NumberFormat({
          style: "currency",
        });

        return formatter.format(value);
      },
    },
  }
</script>

<style lang="scss" scoped>
.text-gold-card {
  color: #bc985f !important;
}
@media screen and (min-width: 321px) {
  .member-card {
    background-size: contain;
    background-repeat: no-repeat;
    width: 350px;
    height: 215px;
    margin: 0 auto;
    position: relative;
  }
  .member-card-text {
    position: absolute;
    bottom: 24px;
    left: -5px;
    right: 0;
    font-size: 12px;
    width: 100%;
    padding: 0 36px;
    color: #FFF;
  }
  .member-card-name {
    font-size: 14px; 
    font-weight: 600;
  }
  .profile-image-wrapper {
    width: 70px;
    height: 70px;
    position: absolute;
    right: 0;
    margin-right: 41px;
    margin-top: 30px;
  }
  .profile-image {
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }
}
// For Iphone 5
@media screen and (max-width: 320px) {
  .member-card {
    background-size: contain;
    background-repeat: no-repeat;
    width: 300px;
    height: 185px;
    margin: 0 auto;
    position: relative;
  }
  .member-card-text {
    position: absolute;
    bottom: 24px;
    left: -5px;
    right: 0;
    font-size: 12px;
    width: 100%;
    padding: 0 32px;
    color: #FFF;
  }
  .member-card-name {
    font-size: 13px; 
    font-weight: 700;
  }
  .profile-image-wrapper {
    width: 60px;
    height: 60px;
    position: absolute;
    right: 0;
    margin-right: 33px;
    margin-top: 25px;
  }
  .profile-image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}
</style>